import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import PilotReducer, { defaultState, asyncActions } from 'src/ducks/pilot.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(PilotReducer, defaultState, asyncActions);
};

type IPilotContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const PilotContext = createContext<Partial<IPilotContext>>({
  state: defaultState,
}) as React.Context<IPilotContext>;

const PilotProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <PilotContext.Provider value={{ ...reducer }}>
      {children}
    </PilotContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const usePilotContext = () => useContext(PilotContext);

export type IUsePilotContext = ReturnType<typeof usePilotContext>;

export { PilotContext, PilotProvider };
